<mat-dialog-content>
  @if (isLoading()) {
  <div class="loading-container">
    <glxy-loading-spinner></glxy-loading-spinner>
  </div>
  } @else {
  <mat-stepper #stepper [linear]="true" [labelPosition]="'bottom'" (selectionChange)="stepChanged($event)">
    <mat-step [stepControl]="form" [completed]="isStepZeroComplete()">
      <ng-template matStepLabel>{{ 'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.UPLOAD_FILES' | translate }}</ng-template>
      <ng-template matStepContent>
        <ai-knowledge-training-progress [config]="trainingProgressConfig" [shouldShowDone]="shouldShowDone()" />
        @if (hasTrainingError()) {
        <glxy-alert type="error" [showAction]="canDismissError()" [actionTitle]="'COMMON.DISMISS' | translate"
          (actionClick)="dismissTrainingError()" [showClose]="false" [extendedBorder]="true">

          <strong>{{ 'EDIT_KNOWLEDGE.TRAINING.TRAINING_ERRORED' | translate }}</strong>

          <glxy-alert-extended>
            @if (isDismissingError()) {
            <glxy-loading-spinner></glxy-loading-spinner>
            } @else {
            @if (canDismissError()) {
            <p>{{ 'EDIT_KNOWLEDGE.TRAINING.TRAINING_DISMISSABLE_ERROR_DESCRIPTION' | translate }}</p>
            } @else {
            <p>{{ 'EDIT_KNOWLEDGE.TRAINING.TRAINING_NON_DISMISSABLE_ERROR_DESCRIPTION' | translate }}</p>
            }

            @if (trainingErrorMessageKey()) {
            <p class="error-details">{{ trainingErrorMessageKey() | translate }}</p>
            }

            @if (erroredFileInfo()) {
            <div class="errored-file-section">
              <div class="file-item">
                <mat-icon>{{ getErroredFileIcon() }}</mat-icon>
                <span class="file-name">{{ getErroredFileName() }}</span>
                <span class="file-type">{{ getErroredFileType() }}</span>
                <glxy-button-group class="inline-button-group">
                  <button mat-stroked-button (click)="viewErroredFile()"
                    [matTooltip]="'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.VIEW_FILE' | translate">
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <button mat-stroked-button (click)="downloadErroredFile()"
                    [matTooltip]="'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.DOWNLOAD_FILE' | translate">
                    <mat-icon>download</mat-icon>
                  </button>
                </glxy-button-group>
              </div>
            </div>
            }
            }
          </glxy-alert-extended>
        </glxy-alert>
        }

        @if (!shouldShowTrainingProgress()) {
        <div class="step-content">
          @if (hasExistingFileOnly()) {
          <div class="existing-file-section">
            <h4>{{ 'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.CURRENT_FILE' | translate }}</h4>
            <div class="existing-file-item">
              <mat-icon>{{ getFileIcon() }}</mat-icon>
              <span class="file-name">{{ getCurrentFileName() }}</span>
              <span class="file-type">{{ getCurrentFileType() }}</span>
              <glxy-button-group class="inline-button-group">
                <button mat-stroked-button (click)="viewCurrentFile()"
                  [matTooltip]="'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.VIEW_FILE' | translate">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button mat-stroked-button (click)="downloadCurrentFile()"
                  [matTooltip]="'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.DOWNLOAD_FILE' | translate">
                  <mat-icon>download</mat-icon>
                </button>
              </glxy-button-group>
            </div>
            <p class="replace-file-text">
              {{ 'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.UPLOAD_NEW_TO_REPLACE' | translate }}
            </p>
          </div>
          }

          <div class="upload-section">
            <h3>{{ 'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.SELECT_FILE' | translate }}</h3>
            <p>{{ 'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.DESCRIPTION' | translate }}</p>

            <glxy-uploader [uploadUrl]="uploadUrl" [maxFiles]="maxFiles" [maxFileSize]="maxFileSize"
              [accept]="acceptedFileTypes" [autoUpload]="true" [layout]="'default'"
              [hintText]="'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.HINT_TEXT' | translate" [descriptionText]="[
                    'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.DRAG_DROP_SINGULAR' | translate,
                    'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.DRAG_DROP_SINGULAR' | translate,
                  ]" [buttonText]="[
                    'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.CHOOSE_FILE_SINGULAR' | translate,
                    'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.CHOOSE_FILE_SINGULAR' | translate,
                  ]" (fileUploaded)="onFileUploaded($event)" (fileUploadErrored)="onFileUploadError($event)"
              (filesChanged)="onFilesChanged($event)"></glxy-uploader>
          </div>

          @if (uploadedFile()) {
          <div class="uploaded-file-section">
            <h4>{{ 'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.UPLOADED_FILE' | translate }}</h4>
            <div class="file-item" [class.success]="uploadedFile().status === 2"
              [class.error]="uploadedFile().status === 3" [class.uploading]="uploadedFile().status === 1">
              <mat-icon>
                @switch (uploadedFile().status) {
                @case (2) {
                check_circle
                }
                @case (3) {
                error
                }
                @default {
                cloud_upload
                }
                }
              </mat-icon>
              <span class="file-name">{{ uploadedFile().name }}</span>
              @if (uploadedFile().status === 1) {
              <span class="uploading-text">{{ 'COMMON.UPLOADING' | translate }}</span>
              }
            </div>
          </div>
          }

          <div class="form-section">
            <form [formGroup]="form">
              <glxy-form-field [required]="true">
                <glxy-label>{{ 'EDIT_KNOWLEDGE.NAME' | translate }}</glxy-label>
                <input matInput formControlName="name"
                  [placeholder]="'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.NAME_PLACEHOLDER' | translate" />
                @if (form.get('name')?.errors && form.get('name')?.dirty) {
                <glxy-error>
                  {{ 'EDIT_KNOWLEDGE.FIELD_REQUIRED' | translate }}
                </glxy-error>
                }
              </glxy-form-field>
            </form>
          </div>

          @if (otherAIDisclaimer()) {
          <div class="disclaimer-section">
            <div [innerHTML]="otherAIDisclaimer()"></div>
          </div>
          }
        </div>
        }
      </ng-template>
    </mat-step>

    @if (!excludeAddToAIStep) {
    <mat-step>
      <ng-template matStepLabel>{{ 'EDIT_KNOWLEDGE.ADD_TO_AI' | translate }}</ng-template>
      <ng-template matStepContent>
        <ai-knowledge-application-selector #applicationSelector [knowledgeSourceId]="$safeNavigationMigration(knowledgeSource()?.id)"
          (createWidgetClicked)="createWebChatWidget()"></ai-knowledge-application-selector>
      </ng-template>
    </mat-step>
    }
  </mat-stepper>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="buttons">
    @if (shouldShowBack()) {
    <div class="card-actions__secondary">
      <button mat-stroked-button (click)="back()">{{ 'COMMON.BACK' | translate }}</button>
    </div>
    }

    <div class="card-actions__primary">
      <button mat-stroked-button (click)="close()">{{ 'COMMON.CLOSE' | translate }}</button>
      @if (!shouldShowDone()) {
      <button mat-flat-button color="primary" (click)="submit()" [disabled]="submitDisabled()">
        {{ submitActionText() | translate }}
      </button>
      }
    </div>
  </div>
</mat-dialog-actions>